import React from "react";
import { useTranslation } from "react-i18next";
import { BotMessageSquare } from "lucide-react";

import type { ChatEmptyStateProps } from "../types/chat.types";

const ChatEmptyState: React.FC<ChatEmptyStateProps> = ({ record, children }) => {
  const { t } = useTranslation();

  const heading = record
    ? t("How can I help with {{name}}?", { name: record.displayName })
    : t("How can I help with this workspace?");

  return (
    <div className="flex h-full flex-col gap-4">
      <div className="flex items-start gap-3 px-1">
        <div className="mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600">
          <BotMessageSquare className="h-5 w-5" />
        </div>
        <div className="min-w-0">
          <h2 className="text-base font-semibold text-gray-900">{heading}</h2>
          <p className="mt-1 text-xs text-gray-500">
            {t(
              "Pick a starter prompt or type your question below. Answers use CRM context for this record."
            )}
          </p>
        </div>
      </div>

      <div className="px-1">{children}</div>

      <div className="px-1 text-[11px] text-gray-400">
        {t("Tip: Shift+Enter for a new line, Enter to send.")}
      </div>
    </div>
  );
};

export default ChatEmptyState;
